<template>
  <div>
    <br />
    <button
      :disabled="current.estatus == false || current.limitar_listado == false"
      class="btn btn-dark btn-block"
      @click="abrirModalAgregarDetalle()"
    >
      <i class="fas fa-plus"></i> Agregar Detalle
    </button>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="nuevaOrdenCompraModal"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg" role="document" style="max-width: 80%">
        <div
          class="modal-content text-center"
          style="width: 100%; max-width: 90%"
        >
          <button
            aria-label="Close"
            class="close"
            @click="cerrarModal()"
            type="button"
          >
            <span class="close-label">Cerrar</span
            ><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-content with-gradient">
            <h5 class="modal-title text-success">Agregar productos a cupón</h5>
            <br />
            <div class="row">
              <div class="col-4">
                <ProductoSelectComponent :current="filter" />
              </div>
              <div class="col-4">
                <ProveedoresSelectComponent :current="filter" />
              </div>
              <div class="col-3">
                <SubCategoriaSelectComponent :current="filter" />
              </div>
              <div class="col-1">
                <br />
                <button
                  @click="refreshtablaAgregarProductos()"
                  class="btn btn-dark"
                >
                  Buscar <i class="fas fa-search"></i>
                </button>
              </div>
              <div class="col-12">
                <button
                  @click="agregar_lista_productos(tablaProducto)"
                  class="btn btn-success btn-block btn-sm"
                >
                  Agregar toda la lista
                </button>
              </div>
              <!-------------------- END - Controles arriba de tabla-------------------->
              <div
                style="overflow-y: scroll; max-height: 700px"
                class="table-responsive"
              >
                <!-------------------- Tabla de REsultados -------------------->
                <table class="table table-striped">
                  <thead
                    style="
                      position: -webkit-sticky;
                      position: sticky;
                      top: 0;
                      z-index: 10;
                      background: #fff;
                    "
                  >
                    <tr>
                      <th class="text-center">SKU</th>
                      <th class="text-center">Producto</th>
                      <th class="text-right">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(detalle, indexDetalle) in tablaProducto"
                      v-bind:key="indexDetalle"
                    >
                      <td v-if="detalle.estatus == false" class="text-center">
                        {{ detalle.producto }}
                      </td>
                      <td v-if="detalle.estatus == false" class="text-center">
                        {{ detalle.producto_nombre }}
                      </td>
                      <td class="text-right" v-if="detalle.estatus == false">
                        <button
                          @click="
                            agregarDetalle(detalle.producto, indexDetalle)
                          "
                          class="btn btn-primary btn-sm"
                        >
                          Agregar producto <i class="fas fa-plus"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h5 v-if="success" class="text-success">
                  Guardado exitosamente! <i class="fas fa-check-double"></i>
                </h5>
                <!-------------------- END - Basic Table -------------------->
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              @click="cerrarModal()"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    ProductoSelectComponent,
    ProveedoresSelectComponent,
    SubCategoriaSelectComponent,
  },
  data() {
    return {
      filter: {},
      success: false,
      tablaProducto: "",
      currentDetalle: {
        producto: "",
      },
    };
  },
  mounted() {},
  props: ["current"],
  methods: {
    cerrarModal() {
      let self = this;
      $("#nuevaOrdenCompraModal").modal("hide");
      self.tablaProducto = "";
    },
    cleanDataFilter() {
      let self = this;
      self.tablaProducto = "";
      self.filtro.producto = "";
      self.filtro.subcategoria = "";
      self.filtro.proveedor = "";
    },
    agregar_lista_productos(list) {
      let self = this;
      DynamicService.postAction(
        "cat",
        "cuponera",
        this.current.id,
        "agregar_lista_productos",
        {
          list,
        }
      )
        .then((response) => {
          if (response.data.length > 0) {
            Notifications.alert.info(
              "Los siguientes skus no se agregaron porque estan inactivos",
              response.data.toString()
            );
          }
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 800);
          this.$emit("refresh", {});
          this.cleanDataFilter();
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Agregar Producto a Cupones",
            errors.response.data.detail
          );
        });
    },
    refreshtablaAgregarProductos() {
      let filtro = Object.assign({}, this.filter);
      if (filtro.producto) {
        filtro.producto = filtro.producto.sku;
      }
      if (filtro.proveedor) {
        filtro.proveedor = filtro.proveedor.codigo;
      }
      if (filtro.subcategoria) {
        filtro.subcategoria = filtro.subcategoria.codigo;
      }
      DynamicService.getActionList(
        "cat",
        "cuponera",
        "traer_productos_proveedor",
        filtro
      ).then((response) => {
        this.tablaProducto = response.data;
      });
    },
    abrirModalAgregarDetalle() {
      $("#nuevaOrdenCompraModal").modal("show");
    },
    agregarDetalle(producto, index) {
      DynamicService.postAction(
        "cat",
        "cuponera",
        this.current.id,
        "agregar_producto",
        {
          producto: producto,
        }
      )
        .then((response) => {
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 800);
          this.$emit("refresh", {});
          this.cleanDataFilter();
          this.tablaProducto[index].estatus = true;
        })
        .catch((errors) => {
          this.tablaProducto[index].estatus = true;
          Notifications.alert.error(
            "Agregar Producto a Cupones",
            errors.response.data.detail
          );
        });
    },
  },
};
</script>
